module.exports = __webpack_public_path__ + "img/facebook.0753f534.png";